import { useCallback, useRef } from "react";

const SWIPE_THRESHOLD_PX = 48;
const SWIPE_AXIS_RATIO = 1.25;

export function useSwipe({ onSwipeLeft, onSwipeRight, enabled = true }) {
  const touchStartRef = useRef(null);

  const onTouchStart = useCallback(
    (event) => {
      if (!enabled || event.touches.length !== 1) return;

      const touch = event.touches[0];
      touchStartRef.current = {
        x: touch.clientX,
        y: touch.clientY,
      };
    },
    [enabled]
  );

  const onTouchEnd = useCallback(
    (event) => {
      if (!enabled || !touchStartRef.current) return;

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStartRef.current.x;
      const deltaY = touch.clientY - touchStartRef.current.y;
      touchStartRef.current = null;

      if (Math.abs(deltaX) < SWIPE_THRESHOLD_PX) return;
      if (Math.abs(deltaX) < Math.abs(deltaY) * SWIPE_AXIS_RATIO) return;

      if (deltaX < 0) {
        onSwipeLeft?.();
      } else {
        onSwipeRight?.();
      }
    },
    [enabled, onSwipeLeft, onSwipeRight]
  );

  const onTouchCancel = useCallback(() => {
    touchStartRef.current = null;
  }, []);

  return {
    onTouchStart,
    onTouchEnd,
    onTouchCancel,
  };
}
